export const RESERVATION_STATUS_PENDING = 'http://schema.org/ReservationPending';
export const RESERVATION_STATUS_HOLD = 'http://schema.org/ReservationHold';
export const RESERVATION_STATUS_CONFIRMED = 'http://schema.org/ReservationConfirmed';
